type TI18nLanguageCode = 'de' | 'en' | 'es' | 'fr' | 'nl' | 'bg' | 'pl' | 'pt' | 'sv' | 'zh';

export const i18nSupportedLangCodes: string[] = ['de', 'en', 'es', 'fr', 'nl', 'bg', 'pl', 'pt', 'sv', 'zh'];

export const availableLanguages: Record<TI18nLanguageCode, string> = {
  de: 'Deutsch',
  en: 'English',
  es: 'Español',
  fr: 'Français',
  nl: 'Nederlands',
  bg: 'Български',
  pl: 'Polski',
  pt: 'Português',
  sv: 'Svenska',
  zh: '中文',
};
